const Auth = resolve => require.ensure([], () => resolve(require('@/views/auth/auth.vue')), 'Auth')
const Login = resolve => require.ensure([], () => resolve(require('@/views/auth/login/login.vue')), 'Login')
const Personal = resolve => require.ensure([], () => resolve(require('@/views/auth/personal/personal.vue')), 'Personal')
const Info = resolve => require.ensure([], () => resolve(require('@/views/auth/info/info.vue')), 'Info')

const LogOut = resolve => require.ensure([], () => resolve(require('@/views/auth/logout/logout.vue')), 'LogOut')
export default [
    {
        path: '/auth',
        component: Auth,
        name: 'auth',
        children: [
            {
                path: '/login',
                component: Login,
                name: 'auth-login',
                meta: {
                    title: '欢迎登陆',
                    icons: 'fa fa-login'
                }
            }, {
                path: 'personal',
                name: 'auth-personal',
                component: Personal,
                meta: {
                    title: '个人中心',
                    icons: 'fa fa-personal',
                    requireAuth: true
                }
            }, {
                path: 'info',
                name: 'auth-info',
                component: Info,
                meta: {
                    title: '个人信息',
                    icons: 'fa fa-personal',
                    // requireAuth: true
                }
            },{
                path:'logout',
                name:'auth-logout',
                component:LogOut,
                meta: {
                    title: '注销登录',
                    icons: 'fa fa-personal',
                    requireAuth: true
                }
            }
        ]
    }
]